import Breadcrumbs from '@mui/material/Breadcrumbs'
import Typography from '@mui/material/Typography'
import Link from '@mui/material/Link'
import Stack from '@mui/material/Stack'
import Tooltip from '@mui/material/Tooltip'
import NavigateNextIcon from '@mui/icons-material/NavigateNext'
import { useNavigate } from 'react-router-dom'
import type { TypographyOwnProps } from '@mui/material/Typography'
import type { SvgIconOwnProps } from '@mui/material/SvgIcon'
import type { SxProps } from '@mui/material/styles'
import { useTheme } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'

export default function CustomSeparator({
  links,
  variant = 'h4',
  fontSize = 'large',
  hasSeparatorEnd,
  sx,
}: {
  links: { name: string; pathname: string }[]
  variant?: TypographyOwnProps['variant']
  fontSize?: SvgIconOwnProps['fontSize']
  hasSeparatorEnd?: boolean
  sx?: SxProps
}) {
  const navigate = useNavigate()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))

  const isShortName = isMobile && links.length > 2

  const lastIndex = links.length - 1
  const breadcrumbs = links.map((link, key) =>
    key === lastIndex ? (
      <Tooltip title={link.name} key={key}>
        <Typography variant={isMobile ? 'h6' : variant} color="text.primary">
          {isShortName && link.name ? link.name[0] + '...' : link.name}
        </Typography>
      </Tooltip>
    ) : (
      <Tooltip title={link.name} key={key}>
        <Link
          underline="hover"
          variant={isMobile ? 'h6' : variant}
          color="inherit"
          onClick={event => {
            event.preventDefault()
            navigate(link.pathname)
          }}
          href={link.pathname}
        >
          {isShortName && link.name ? link.name[0] + '...' : link.name}
        </Link>
      </Tooltip>
    )
  )

  return (
    <Stack direction="row" alignItems="center" gap="0.5rem" sx={sx}>
      <Breadcrumbs separator={<NavigateNextIcon fontSize={fontSize} />} aria-label="breadcrumb">
        {breadcrumbs}
      </Breadcrumbs>
      {hasSeparatorEnd ? <NavigateNextIcon fontSize={fontSize} /> : false}
    </Stack>
  )
}
